import { type TGlobalFunctionTyped } from 'common/hooks/useTranslation';

export type SubscriptionInterval =
  | 'MONTHLY'
  | 'YEARLY'
  | 'QUARTERLY'
  | null
  | undefined;

export function getSubscriptionIntervalTranslation(
  t: TGlobalFunctionTyped,
  subscriptionInterval: SubscriptionInterval,
) {
  switch (subscriptionInterval) {
    case 'QUARTERLY':
      return t('subscriptions.panelDetails.recurrence.quarterly');
    case 'YEARLY':
      return t('subscriptions.panelDetails.recurrence.yearly');
    default:
      return t('subscriptions.panelDetails.recurrence.monthly');
  }
}
